export default function() {

    var width = 750;
    var dw = document.documentElement.clientWidth;
    var _zoom = dw / width * 100;
    document.getElementsByTagName('html')[0].style.fontSize = _zoom + "px";
}